module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/games.c7f51191.png";